<template>
	<div class="layout-footer" style="display:none">
		Canary Data Solutions Ltd
	</div>
</template>

<script>
</script>

<style scoped>
</style>